import React, { Component, PropTypes } from 'react'

import Modal from './modal'

class ModalContainer extends Component {

  scrollToTop() {
    this.ref.scrollToTop()
  }

  render() {
    return (
      <Modal
        ref={(c) => { this.ref = c }}
        closeModal={this.props.closeModal}
        isOpen={this.props.isOpen}
        light={this.props.light}
        title={this.props.title}
        wide={this.props.wide}
      >
        {this.props.children}
      </Modal>
    )
  }

}

ModalContainer.propTypes = {
  children: PropTypes.node,
  closeModal: PropTypes.func,
  isOpen: PropTypes.bool,
  light: PropTypes.bool,
  title: PropTypes.string,
  wide: PropTypes.bool,
}

export default ModalContainer



/** WEBPACK FOOTER **
 ** ./src/components/modal/modal-container.js
 **/